import { setCurrentProject } from '@utils/axios'
import { isServer } from '@utils/isServer'
import { getCookie, setCookie } from 'cookies-next'

export const CURRENT_PROJECT_ID_COOKIE_NAME = 'app-current-project-id'

export function setProjectId(projectId: string) {
  if (!isServer()) {
    setCurrentProject(projectId)

    setCookie(CURRENT_PROJECT_ID_COOKIE_NAME, projectId, {
      path: '/',
      httpOnly: false,
      maxAge: 60 * 60 * 24 * 3650,
    })
  }
}

export function getProjectId() {
  const cookieValue = isServer()
    ? getCookie(CURRENT_PROJECT_ID_COOKIE_NAME, { cookies: require('next/headers').cookies })
    : getCookie(CURRENT_PROJECT_ID_COOKIE_NAME)
  return cookieValue ? String(cookieValue) : '-1'
}
